/**
 * BroadcastsSelectSection - Select broadcasts for an event
 * Extracted from EventsTab.jsx
 */
import { Radio } from "lucide-react";
import { formatTime12Hour } from "../utils";

export const BroadcastsSelectSection = ({ formData, setFormData, broadcasts }) => {
  const toggleBroadcast = (broadcastId) => {
    const isSelected = formData.broadcast_ids.includes(broadcastId);
    setFormData({
      ...formData,
      broadcast_ids: isSelected 
        ? formData.broadcast_ids.filter(id => id !== broadcastId)
        : [...formData.broadcast_ids, broadcastId]
    });
  };

  return (
    <div className="border-t border-white/10 pt-6">
      <h4 className="font-secondary text-sm font-bold uppercase text-white mb-4 flex items-center gap-2">
        <Radio className="w-4 h-4" /> Event Broadcasts
      </h4>
      
      <p className="text-xs text-zinc-500 mb-4">Select broadcasts to include in this event</p>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 max-h-[300px] overflow-y-auto p-2 bg-zinc-800/30 border border-white/5">
        {broadcasts.length === 0 ? (
          <p className="text-zinc-600 text-sm col-span-2 py-4 text-center">No upcoming broadcasts available</p>
        ) : (
          broadcasts.map(broadcast => (
            <label 
              key={broadcast.id} 
              className={`flex items-center gap-3 p-3 cursor-pointer transition-colors ${
                formData.broadcast_ids.includes(broadcast.id) 
                  ? 'bg-white/10 border-white/20' 
                  : 'bg-zinc-900/50 border-white/5 hover:bg-zinc-900'
              } border`}
            >
              <input 
                type="checkbox" 
                checked={formData.broadcast_ids.includes(broadcast.id)}
                onChange={() => toggleBroadcast(broadcast.id)}
                className="w-4 h-4"
              />
              <div className="flex-1 min-w-0">
                <p className="text-sm text-white truncate">{broadcast.title}</p>
                <p className="text-xs text-zinc-500">
                  {broadcast.scheduled_date} • {formatTime12Hour(broadcast.scheduled_time)} • {broadcast.sport}
                </p>
              </div>
            </label>
          ))
        )}
      </div>
      
      {formData.broadcast_ids.length > 0 && (
        <p className="text-xs text-zinc-400 mt-2">{formData.broadcast_ids.length} broadcast(s) selected</p>
      )}
    </div>
  );
};

export default BroadcastsSelectSection;
